/**
 * Because all bracelets must behave similarly for standard actions such as
 * connection/disconnection, this module takes care
 * of general bracelet requirements such as: configuration, how to handle alerts,
 * listening to a battery, etc.
 */

/**
 * This module provides interaction with all the bracelets that the current
 * machine is physically connected to (via Bluetooth).  It's state is an
 * array of objects with key = mac and value is an object {id: mac, model: string}
 */

var Model = require("../types/Model.js");
var par = require("par");

module.exports = new Model({
	name: "bracelets",
	init: init,
	listeners: listeners,
	vlrtConnection: vlrtConnection,

	_serial: null
});

function init() {
	this.push({});
}

function listeners() {
	return {
		"bluetooth:connected": handleDeviceConnected,
		"bluetooth:disconnected": handleDeviceDisonnected,
		"machinetracker:updated": handleMachineTrackerUpdated,
	};
}

function handleMachineTrackerUpdated(data) {
	this._serial = data.serial;
}

function handleDeviceConnected(device) {
	var mac = device.id;
	var model = device.model;
	var cleanMac = hyphenateMac(mac);

	// Set up listeners for various vlrt bracelet actions
	if (!model || model === "vlrt") {
		this.vlrtConnection(mac);
	} else {
		return;
	}

	this.tracker.on("mqtt:bracelet/" + cleanMac + "/disconnect", par(handleDeviceDisconnectRequest, mac));

	// Notify system that we're connected
	this.emit("$mqtt:bracelet/" + cleanMac + "/connected", {
		machine: this._serial
	});

	// Extend with the button's data
	var extension = {};
	extension[mac] = device;
	this.extend(extension);
}

// Set up listeners for various bracelet events.
function vlrtConnection(mac) {
	var cleanMac = hyphenateMac(mac);

	// Send verification to the bracelet
	this.emit("braceletevents:trigger:verify", {
		bracelet: mac
	});

	// Listen on presses/falls
	this.emit("braceletevents:trigger:listen:notifications", {
		bracelet: mac
	});

	// Start polling the battery
	this.emit("braceletevents:trigger:listen:battery", {
		bracelet: mac
	});

	// Set preferences for getting both button presses and falls
	this.emit("braceletevents:trigger:configure", {
		bracelet: mac
	});

	// Turn of the blinking in case it's on
	this.emit("braceletevents:trigger:alert:off", {
		bracelet: mac
	});

	this.tracker.on("mqtt:bracelet/" + cleanMac + "/alert/alert", par(handleDeviceAlertRequest, mac));
	this.tracker.on("mqtt:bracelet/" + cleanMac + "/alert/on", par(handleDeviceAlertOnRequest, mac));
	this.tracker.on("mqtt:bracelet/" + cleanMac + "/alert/off", par(handleDeviceAlertOffRequest, mac));
}

function handleDeviceAlertRequest(mac) {
	this.emit("braceletevents:trigger:alert:alert", {
		bracelet: mac
	});
}

function handleDeviceAlertOnRequest(mac) {
	this.emit("braceletevents:trigger:alert:on", {
		bracelet: mac
	});
}

function handleDeviceAlertOffRequest(mac) {
	this.emit("braceletevents:trigger:alert:off", {
		bracelet: mac
	});
}

function handleDeviceDisconnectRequest(mac) {
	this.emit("braceletevents:trigger:disconnect", {
		bracelet: mac
	});
}

function handleDeviceDisonnected(mac) {
	var cleanMac = mac.replace(/:/g, "-");
	if (!this.data[mac]) return;
	var model = this.data[mac].model;
	if (!model || model !== "vlrt") return;

	// Stop listening on on presses/falls
	this.emit("braceletevents:trigger:listen:stop:notifications", {
		bracelet: mac
	});

	// Stop polling the battery
	this.emit("braceletevents:trigger:listen:stop:battery", {
		bracelet: mac
	});

	this.tracker.off("mqtt:bracelet/" + cleanMac + "/alert/alert");
	this.tracker.off("mqtt:bracelet/" + cleanMac + "/alert/on");
	this.tracker.off("mqtt:bracelet/" + cleanMac + "/alert/off");


	// Notify system that we're disconnected
	this.emit("$mqtt:bracelet/" + cleanMac + "/disconnected", {
		machine: this._serial,
		reason: "disconnected"
	});

	this.tracker.off("mqtt:bracelet/" + cleanMac + "/disconnect");

	// Remove button's data by setting its key to null
	var extension = {};
	extension[mac] = null;
	this.extend(extension);
}

function hyphenateMac(mac) {
	var cleanMac = mac.replace(/:/g, "-");
	return cleanMac;
}
